export default "__VITE_ASSET__48ab36ad__"